import { a as e, c as t, d as n, en as r, f as i, h as a, i as o, l as s, m as c, n as l, nn as u, o as d, p as f, r as p, s as m, t as h, tn as g } from "./sdk.gen-DvYHZRAO.js";
//#region src/utils/querySerializer.ts
var _ = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, v = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, y = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, b = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(v(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = _(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : C(n, t, { allowReserved: e })).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, x = ({ allowReserved: e, name: t, value: n }) => n == null ? "" : `${t}=${e ? n : encodeURIComponent(n)}`, S = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = y(r), s = Object.entries(i).map(([t, i]) => C(r === "deepObject" ? `${n}[${t}]` : t, i, { allowReserved: e })).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, C = (e, t, { allowReserved: n, array: r, object: i } = {}) => t == null ? "" : Array.isArray(t) ? b({
	allowReserved: n,
	explode: !0,
	name: e,
	style: "form",
	value: t,
	...r
}) : typeof t == "object" ? S({
	allowReserved: n,
	explode: !0,
	name: e,
	style: "deepObject",
	value: t,
	...i
}) : x({
	allowReserved: n,
	name: e,
	value: t
}), w = ({ allowReserved: e, array: t, object: n } = {}) => (r) => {
	let i = [];
	if (r && typeof r == "object") for (let a in r) {
		let o = r[a], s = C(a, o, {
			allowReserved: e,
			array: t,
			object: n
		});
		s && i.push(s);
	}
	return i.join("&");
}, T = () => r.getConfig().auth, E = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let t = {
		baseUrl: u,
		auth: e.token,
		querySerializer: w()
	};
	return e.environment && e.environment === "acceptance" && (t.baseUrl = g), e.locale && (t.headers = {
		...t.headers,
		"Accept-Language": e.locale
	}), r.setConfig(t), e.token;
}, D = (e) => {
	r.setConfig({ headers: {
		...r.getConfig().headers,
		"Accept-Language": e
	} });
}, O = async (e) => (await d({ body: e })).data, k = async (e) => (await o({ body: e })).data, A = async (e, t) => (await h({
	query: e,
	signal: t.signal
})).data, j = async (e) => (await m({ body: e })).data, M = async (e) => (await c({ body: e })).data, N = async (e) => (await s({ body: e })).data, P = async (e) => (await f({ body: e })).data, F = async (e) => (await t({ body: e })).data, I = async (t) => (await e({ body: t })).data, L = async (e) => (await i({ body: e })).data, R = async (e) => (await a({ body: e })).data, z = async (e) => (await n({ body: e })).data, B = async (e, t) => {
	let n = r.getConfig().headers, i = t?.printerGroupId ? `application/pdf+print;printer-group-id=${t.printerGroupId}` : "application/pdf";
	return (await p({
		query: e,
		headers: {
			Accept: i,
			...n?.["Accept-Language"] && { "Accept-Language": n?.["Accept-Language"] },
			"content-type": "application/json"
		},
		requestValidator: (e) => e
	})).data;
}, V = async (e, t) => {
	let n = r.getConfig().headers, i = t?.printerGroupId ? `application/pdf+print;printer-group-id=${t?.printerGroupId}` : "application/pdf";
	return (await l({
		query: e,
		headers: {
			Accept: i,
			...n?.["Accept-Language"] && { "Accept-Language": n?.["Accept-Language"] },
			"content-type": "application/json"
		},
		requestValidator: (e) => e
	})).data;
}, H = () => ({
	getOrders: A,
	getPackingSlips: V,
	getPicklist: B,
	getToken: T,
	initClient: E,
	postAddOrderNote: k,
	postAddPackages: I,
	postAssignOrdersToUser: O,
	postCancelOrders: j,
	postCreateFromShippablePackages: F,
	postEditOrderNote: N,
	postImportOrders: z,
	postPreparePackagesForShipment: L,
	postRemoveOrderNotes: P,
	postUnassignOrdersFromUser: M,
	postUnpreparePackagesForShipment: R,
	setAcceptLanguageHeader: D
});
//#endregion
export { H as t };
